import React from 'react';
import PropTypes from 'prop-types';
import Select from 'pages/reference-implementation/components/select';

const ApplicationService = ({ value, onChange, isRequired, errorMessage }) => {
    const options = value ? [{ label: value, value }] : [];

    return (
        <Select
            key="applicationService"
            label="Application Service *"
            value={value || null}
            options={options}
            onChange={(event, selectedValue) => {
                onChange('applicationService', selectedValue?.value || '');
            }}
            isRequired={isRequired}
            error={!!errorMessage}
            helperText={errorMessage}
            disabled
        />
    );
};

ApplicationService.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    isRequired: PropTypes.bool,
    errorMessage: PropTypes.string,
};

ApplicationService.defaultProps = {
    value: '',
    isRequired: false,
    errorMessage: '',
};

export default ApplicationService;
